import { Component, Input } from '@angular/core'
import { SearchboxComponent } from '../../../components/searchbox/searchbox.component'
import { RouterLink } from '@angular/router'
import { CommonModule, SlicePipe } from '@angular/common'
import { ResearchService } from '../../../services/research.service'
import { QuestionAndAnswer } from '../../../types'
import { TranslocoModule, TranslocoService } from '@jsverse/transloco'
import { ConfigService } from '../../../services/config.service'
import { StatisticsService } from '../../../services/statistics.service'
import { UserService } from '../../../services/user.service'

@Component({
   selector: 'app-landing',
   standalone: true,
   imports: [CommonModule, SearchboxComponent, RouterLink, SlicePipe, TranslocoModule],
   templateUrl: './landing.component.html',
   // this host adds a 'contents' class, which more or less hides the element from the CSS hierarchy, making the flex box thing work properly
   // eslint-disable-next-line @angular-eslint/no-host-metadata-property
   host: {
      class: 'contents'
   }
})
export class LandingComponent {
   initialQuestions!: QuestionAndAnswer[]

   get showBeta() {
      return this.config.currentConfig.showBeta
   }

   get quotumLimitExceeded() {
      return this.research.quotumLimitExceeded
   }

   @Input() helpLink = '/pages/help'

   // TODO get this from the API
   constructor(private research: ResearchService, transloco: TranslocoService, private config: ConfigService, private user: UserService, private stats: StatisticsService) {
      // wait on localization to be ready
      transloco.selectTranslate('landing.research.question1').subscribe(() => {
         this.initialQuestions = [{
            id: 'question1',
            question: transloco.translate('landing.research.question1')
         },
         {
            id: 'question2',
            question: transloco.translate('landing.research.question2')
         },
         {
            id: 'question3',
            question: transloco.translate('landing.research.question3')
         },
         {
            id: 'question4',
            question: transloco.translate('landing.research.question4')
         }]
      })
   }

   getAnswer($event: Event, question: string) {
      $event.preventDefault()
      this.research.getAnswer(question, null)
      this.stats.search(question, 'landing')
   }
}
